import React, { useState, useEffect } from "react"
import { Container } from '../Container/Container'
import Svg from "../../assets/icons/icons"

import {
  ScrollTopSt,
  ScrollTopBtnSt,
} from "./style";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible((window.pageYOffset > 300) ? true : false);
    };

    document.addEventListener("scroll", toggleVisibility);
    // в классовой версии слушатель не снимался — здесь чистим при размонтировании
    return () => { document.removeEventListener("scroll", toggleVisibility) };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <ScrollTopSt>
      <Container>
        {isVisible && (
          <div className="wrap-scroll-btn" onClick={() => scrollToTop()} style={{ position: "relative" }}>
            <ScrollTopBtnSt>
              <Svg type="keyboard_arrow" />
            </ScrollTopBtnSt>
          </div>
        )}
      </Container>
    </ScrollTopSt>
  );
};

export default ScrollToTop;
